module.exports = __webpack_public_path__ + "img/manifeste.64ca7556.jpg";